import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "workspace-icon",
  "use": "workspace-icon-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"workspace-icon\"><rect x=\"8.615\" width=\"7.385\" height=\"14\" rx=\"1\" /><rect width=\"7.385\" height=\"4.667\" rx=\"1\" /><rect y=\"5.833\" width=\"7.385\" height=\"8.167\" rx=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol